import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// TODO: Replace these values with actual Firebase project config

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// Prevent re-initializing the app on hot reloads
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();
// console.log("API KEY:", process.env.REACT_APP_FIREBASE_API_KEY);

export const auth = getAuth(app);
export const db = getFirestore(app);

export default app;
